import { OPEN_RX } from 'src/feature-flags_';
import { PageScene, useOpenRx, usePageScene } from 'src/views/main/scene-context';

export const useIsEnableRedux = () => {
  const pageScene = usePageScene();
  const openRx = useOpenRx();

  const isUseRedux =
    pageScene &&
    [PageScene.PAGE_HISTORY, PageScene.PAGE_FEEDS, PageScene.PAGE_CHART].includes(pageScene);

  // 以后可能会有更多case，所以不合并判断

  // 禁用了，就不用考虑。直接关
  if (!OPEN_RX) {
    return true;
  }

  // 某些情况下必须得使用 redux
  if (isUseRedux) {
    return true;
  }

  // 如果 context 使用了 redux。或者用户主动开启了 beta 模式。就走 rx
  if (openRx) {
    return false;
  }

  // 默认情况下都走 redux
  return true;
};
